import React, { useState } from "react";
import v1 from "../Accests/images/Fireworks/VID-20250630-WA0003.mp4";
import v2 from "../Accests/images/Fireworks/VID-20250630-WA0005 (1).mp4";
import v3 from "../Accests/images/Fireworks/VID-20250630-WA0006.mp4";
import v4 from "../Accests/images/Fireworks/VID-20250630-WA0008.mp4";

const Fireworks = () => {
    const [previewSrc, setPreviewSrc] = useState(null);

    const openPreview = (src) => {
        setPreviewSrc(src);
    };

    const closePreview = () => {
        setPreviewSrc(null);
    };

    return (
        <>
            <div className="pt-24 px-6 bg-gray-100 min-h-screen">
                <h1 className="text-4xl font-bold text-center mb-8 text-purple-600">Fireworks</h1>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[v1, v2, v3, v4].map((video, index) => (
                        <video
                            key={index}
                            src={video}
                            onClick={() => openPreview(video)}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                            muted
                            autoPlay
                            loop
                        />
                    ))}
                </div>

                <p className="text-gray-700 mt-6 text-lg leading-relaxed text-center">
                    Experience a magical night filled with breathtaking fireworks displays that light up the sky.
                </p>
            </div>

            {/* Preview Modal */}
            {previewSrc && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
                    {/* Overlay to capture click outside */}
                    <div className="absolute inset-0" onClick={closePreview}></div>

                    <div className="relative z-10 max-w-4xl w-full px-4">
                        <button
                            onClick={closePreview}
                            className="absolute top-6 right-6 z-20 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-red-600 hover:text-white transition"
                        >
                            &times;
                        </button>

                        <video
                            src={previewSrc}
                            className="w-full rounded-lg z-10 relative"
                            controls
                            autoPlay
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default Fireworks;
